/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  tagList: []
};
function constructData() {}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.TagActions.REQUEST_GET_TAGS_LIST:
      return {
        ...state
      };
    case actions.TagActions.TAGS_LIST_RECEIVED:
      return {
        ...state,
        tagList: action.data.projectTags
      };

    default:
      return state;
  }
};

export default reducer;
